import { closeModal } from "../../../ui/containers/Modal";
import { ButtonComp } from "../../../ui/input/Button";
import { promptInput } from "../../../ui/input/PromptInput";
import { ComponentF, createElement } from "../../../ui/ui";
import { gameData } from "../../GameManager";

export const PlayerPosition: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C, props) => {
  const [state, setState] = C.useState({ x: 0, y: 0 });

  return [
    createElement(
      ButtonComp,
      { x: 0, y: 0, w: 6, h: 1 },
      {
        title: `X: ${state.x}`,
        onClick: () =>
          promptInput({
            title: "X",
            initial: state.x,
            onSubmit: (v) => setState({ x: parseInt(v) }),
          }),
      }
    ),
    createElement(
      ButtonComp,
      { x: 8, y: 0, w: 6, h: 1 },
      {
        title: `Y: ${state.y}`,
        onClick: () =>
          promptInput({
            title: "Y",
            initial: state.y,
            onSubmit: (v) => setState({ y: parseInt(v) }),
          }),
      }
    ),
    createElement(
      ButtonComp,
      { x: 34, y: 0, w: 6, h: 1 },
      {
        title: "Move",
        onClick: () => {
          gameData.player.x = state.x;
          gameData.player.y = state.y;
          closeModal();
        },
      }
    ),
  ];
};
